import { useState, useEffect } from "react";
import {
  emptyPartner,
  emptyAddress,
  emptyTax,
  emptyBank,
  emptyContact,
} from "../models/bpDefaults";

export default function useBusinessPartnerForm(record, open) {
  const [form, setForm] = useState(emptyPartner);

  useEffect(() => {
    if (record) {
      setForm({
        ...emptyPartner,
        ...record,
        addresses: record.addresses || [],
        contacts: record.contacts || [],
        taxes: record.taxes || [],
        banks: record.banks || [],
        roles: record.roles || [],
      });
    } else {
      setForm(emptyPartner);
    }
  }, [record, open]);

  /* ================= ADDRESS ================= */

  const addAddress = (data) =>
    setForm((p) => ({
      ...p,
      addresses: [...p.addresses, data || { ...emptyAddress }],
    }));

  const updateAddress = (index, updated) => {
    setForm((p) => {
      const list = [...p.addresses];
      list[index] = updated;
      return { ...p, addresses: list };
    });
  };

  const removeAddress = (index) => {
    setForm((p) => ({
      ...p,
      addresses: p.addresses.filter(
        (_, i) => i !== index
      ),
    }));
  };

  const setDefaultAddress = (index) => {
    setForm((p) => ({
      ...p,
      addresses: p.addresses.map((a, i) => ({
        ...a,
        is_default: i === index,
      })),
    }));
  };

  /* ================= CONTACT ================= */

  const addContact = (data) =>
    setForm((p) => ({
      ...p,
      contacts: [...p.contacts, data || { ...emptyContact }],
    }));

  const updateContact = (index, updated) => {
    setForm((p) => {
      const list = [...p.contacts];
      list[index] = updated;
      return { ...p, contacts: list };
    });
  };

  const removeContact = (index) => {
    setForm((p) => ({
      ...p,
      contacts: p.contacts.filter(
        (_, i) => i !== index
      ),
    }));
  };

  /* ================= TAX ================= */

  const addTax = (data) =>
    setForm((p) => ({
      ...p,
      taxes: [...p.taxes, data || { ...emptyTax }],
    }));

  const updateTax = (index, updated) => {
    setForm((p) => {
      const list = [...p.taxes];
      list[index] = updated;
      return { ...p, taxes: list };
    });
  };

  const removeTax = (index) => {
    setForm((p) => ({
      ...p,
      taxes: p.taxes.filter((_, i) => i !== index),
    }));
  };

  /* ================= BANK ================= */

  const addBank = (data) =>
    setForm((p) => ({
      ...p,
      banks: [...p.banks, data || { ...emptyBank }],
    }));

  const updateBank = (index, updated) => {
    setForm((p) => {
      const list = [...p.banks];
      list[index] = updated;
      return { ...p, banks: list };
    });
  };

  const removeBank = (index) => {
    setForm((p) => ({
      ...p,
      banks: p.banks.filter(
        (_, i) => i !== index
      ),
    }));
  };

  const setDefaultBank = (index) => {
    setForm((p) => ({
      ...p,
      banks: p.banks.map((b, i) => ({
        ...b,
        is_default: i === index,
      })),
    }));
  };

  /* ================= EXPORT ================= */

  return {
    form,
    setForm,

    // address
    addAddress,
    updateAddress,
    removeAddress,
    setDefaultAddress,

    // contact
    addContact,
    updateContact,
    removeContact,

    // tax
    addTax,
    updateTax,
    removeTax,

    // bank
    addBank,
    updateBank,
    removeBank,
    setDefaultBank,
  };
}
